<template>
  <div class="mk-concert-page mk-container">
    <Paganiniplus style="margin-bottom: 24px;" />
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <div v-if="loaded">
      <div class="content-info">
        <div v-if="eventContent && eventContent.file_link" class="image">
          <img v-img-loader
               :data-src="eventContent.file_link"
               :data-default-src="'/img/img-default/img-playlist-default-l.png'"
               :alt="eventContent.title"
          >
        </div>
        <div v-else-if="eventContent" class="image">
          <img v-img-loader
               :data-default-src="'/img/img-default/img-playlist-default-l.png'"
          >
        </div>
        <div class="desp">
          <h1 class="title">
            {{ eventContent && eventContent.title ? eventContent.title : '' }}
          </h1>
          <a rel="noopener noreferrer"
             class="mk-btn mk-btn--default btn-buy"
             :class="{ 'show-btn-buy': allShowsAreExpired }"
             @click="goBuyTicket(eventContent && eventContent.ticket_url)"
          >
            {{ $t('CONCERT.BUY_TICKET') }}
          </a>
        </div>
      </div>
      <a rel="noopener noreferrer"
         class="mk-btn mk-btn--primary btn-buy-m"
         :class="{ 'show-btn-buy': allShowsAreExpired }"
         @click="goBuyTicket(eventContent && eventContent.ticket_url)"
      >
        {{ $t('CONCERT.BUY_TICKET') }}
      </a>
      <div style="font-size: 12px; color: #6e6e6e; margin-bottom: 20px;">
        {{ $t('CONCERT.POSTSCRIPT') }}
      </div>
      <div v-if="eventContent.venues"
           class="mk-table mk-table-concert-info event-info"
      >
        <div class="table-th table-tr">
          <div class="table-td">
            {{ $t('CONCERT.PERFORMANCE_TIME') }}
          </div>
          <div class="table-td">
            {{ $t('CONCERT.PERFORMANCE_VENUE') }}
          </div>
        </div>
        <div v-for="(venue, index) in eventContent.venues" :key="index" class="table-tr">
          <div class="table-td date">
            {{ venue.datetime }}
            <!-- (UTC+{{ getGMTHours(venue.datetime) }}) -->
          </div>
          <div class="table-td location">
            {{ venue.name }}
            <a v-if="locationMapLink(venue, venue.name)" :href="locationMapLink(venue, venue.name)"
               target="_blank" rel="noopener noreferrer" class="btn-location"
            >
              <i class="material-icons">
                location_on
              </i>
            </a>
          </div>
        </div>
      </div>
      <div class="event-content" v-html="eventContent && eventContent.description" />
      <div>
        <Paganiniplus />
      </div>
    </div>
    <div v-else class="loader-container">
      <Loader />
    </div>
    <div id="allmap" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/common/Breadcrumbs'
import Loader from '@/components/common/Loader'
import Paganiniplus from '@/components/tsp/Paganiniplus'
import ImgLoader from '@/directives/ImgLoader'
import EventService from '@/assets/services/EventService'

export default {
  name: 'ConcertSubPage',
  components: {
    Breadcrumbs,
    Loader,
    Paganiniplus
  },
  directives: {
    ImgLoader
  },
  props: {},
  data() {
    return {
      // breadcrumbs: this.$route.meta.breadcrumbs,
      loaded: false,
      eventContent: {},
      isCN: this.$isCN,
      coordinateList: {
        cn: '116.404, 39.915',
        tw: '120.361327, 23.777224',
        us: '-95.694781, 37.014434',
        jp: '31.662, lat: 120.168'
      },
      allShowsAreExpired: false
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        ...this.$route.meta.metaInfo.meta,
        { vmid: 'name', name: 'name', content: this.title },
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'image', name: 'image', content: this.cover },
        { vmid: 'keywords', name: 'keywords', content: this.keywords },
        { vmid: 'og:title', name: 'og:title', content: this.title },
        { vmid: 'og:description', name: 'og:description', content: this.description },
        { vmid: 'og:image', name: 'og:image', content: this.cover },
        { vmid: 'og:url', name: 'og:url', content: this.canonicalURL }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.canonicalURL },
        { vmid: 'image_src', rel: 'image_src', href: this.cover }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [{ innerHTML: JSON.stringify(this.structuredData), type: 'application/ld+json' }]
    }
  },
  computed: {
    breadcrumbs() {
      let breadcrumbsAry = []
      const indexBreadcrumbs = { routeName: 'index', localeLabel: 'CONCERT.TITLE', redirectPath: '' }
      breadcrumbsAry.push(indexBreadcrumbs)
      const eventBreadcrumbs = {
        routeName: 'eventById',
        localeLabel: this.eventContent.title || 'CONCERT.PERFORMANCE_TITLE',
        redirectPath: ''
      }
      breadcrumbsAry.push(eventBreadcrumbs)
      return breadcrumbsAry
    },
    title() {
      const titlePostfix = `${this.$t('CONCERT.TITLE')} | MUZIK AIR`
      return this.eventContent && this.eventContent.title ? `${this.eventContent.title} | ${titlePostfix}` : titlePostfix
    },
    description() {
      return this.eventContent && this.eventContent.description ? this.eventContent.description : this.$t('CONCERT.TITLE')
    },
    keywords() {
      return this.eventContent && this.eventContent.tilte ? this.eventContent.tilte : this.$t('CONCERT.TITLE')
    },
    cover() {
      return this.eventContent && this.eventContent.cover
        ? this.eventContent.cover
        : `https://${process.env.VUE_APP_MUZIK_CONCERT}.${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/concert.png`
    },
    canonicalURL() {
      return this.eventContent && this.eventContent.id
        ? `https://${process.env.VUE_APP_MUZIK_CONCERT}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/events/${this.eventContent.id}`
        : `https://${process.env.VUE_APP_MUZIK_CONCERT}.${process.env.VUE_APP_MUZIK_DOMAIN}`
    },
    structuredData() {
      return [
        {
          '@context': 'http://schema.org',
          '@type': 'Article',
          '@id': this.canonicalURL,
          'mainEntityOfPage': {
            '@type': 'WebPage',
            '@id': `https://${process.env.VUE_APP_MUZIK_CONCERT}.${process.env.VUE_APP_MUZIK_DOMAIN}`
          },
          'headline': this.title,
          'name': this.title,
          'image': this.cover,
          'keywords': this.keywords,
          'url': this.canonicalURL,
          'publisher': {
            '@type': 'Organization',
            'name': 'MUZIK AIR',
            'logo': {
              '@type': 'ImageObject',
              'url': `https://${process.env.VUE_APP_MUZIK_CONCERT}.${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/concert.png`
            }
          },
          'description': this.description
        },
        {
          '@context': 'http://schema.org',
          '@type': 'BreadcrumbList',
          'itemListElement': [{
            '@type': 'ListItem',
            'position': 1,
            'item': {
              '@id': `https://${process.env.VUE_APP_MUZIK_CONCERT}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/`,
              'name': this.$t('CONCERT.TITLE')
            }
          }]
        }
      ]
    }
  },
  async created() {
    if (this.$route.params.id) {
      const promiseList = [this.loadBaiduSDK()]
      await Promise.all(promiseList)
      this.getEventsById(this.$route.params.id)
    }
  },
  mounted() {
  },
  methods: {
    async getEventsById(eventId) {
      let res = await EventService.getEventById(eventId)
      if (res && res.id) {
        this.eventContent = res
        const currentDate = this.$moment().format('YYYY-MM-DD')
        this.allShowsAreExpired = this.eventContent.venues.every(venue => {
          const venueDate = this.$moment(venue.datetime, 'YYYY-MM-DD HH:mm (UTC Z)').format('YYYY-MM-DD')
          return this.$moment(venueDate).isBefore(currentDate)
        })
      }
      this.loaded = true
    },
    goBuyTicket(targetUrl) {
      // GTAG Event
      this.$store.dispatch('GTAG_EVENT', {
        action: 'concert_buytickets_click',
        data: {
          event_category: 'buyTicketsBtn',
          event_label: 'buyTickets ' + targetUrl
        }
      })
      if (targetUrl) {
        window.open(targetUrl, '_blank')
      }
    },
    timeConverter(unixTimestamp) {
      let date = new Date(unixTimestamp * 1000)
      let year = date.getFullYear()
      let month = ('0' + (date.getMonth() + 1)).substr(-2)
      let day = ('0' + date.getDate()).substr(-2)
      let hour = ('0' + date.getHours()).substr(-2)
      let min = ('0' + date.getMinutes()).substr(-2)
      return year + '-' + month + '-' + day + ' ' + hour + ':' + min
    },
    getGMTHours(unixTimestamp) {
      let date = new Date(unixTimestamp * 1000)
      let gmtHours = -date.getTimezoneOffset() / 60
      return +gmtHours
    },
    async loadBaiduSDK() {
      /* eslint-disable */
      const key = 'nG4tbI65yj1P22RQb6TC7g7GMhbli4zd'
      const baiduURL = 'https://api.map.baidu.com/api?v=2.0&ak=' + key + '&s=1&callback=onBMapCallback'
      return new Promise((resolve, reject) => {
        if (typeof BMap !== 'undefined') {
          resolve(BMap)
          return true
        }
        window.onBMapCallback = function () {
          // console.log("BMap Loaded")
          resolve(BMap)
        }
        let scriptNode = document.createElement('script')
        scriptNode.setAttribute('type', 'text/javascript')
        scriptNode.setAttribute('src', baiduURL)
        document.body.appendChild(scriptNode)
      })
      /* eslint-enable */
    },
    async findLocation(venue, keyword) {
      /* eslint-disable */
      let map = new BMap.Map('allmap')
      let loc = this.coordinateList[venue.country_id].split(",")
      let point = new BMap.Point(parseFloat(loc[0]), parseFloat(loc[1]))
      map.centerAndZoom(point, 12)
      let link = ''
      let options = {
        onSearchComplete: (results) => {
          if (local.getStatus() === BMAP_STATUS_SUCCESS) {
            for (var i = 0; i < results.getCurrentNumPois(); i++) {
              link = results.moreResultsUrl.trim()
            }
            this.$set(venue, 'baiduUrl', link)
          }
        }
      }
      let local = new BMap.LocalSearch(map, options)
      let tempKeyword = keyword.split(':')
      keyword = tempKeyword.length > 1 ? tempKeyword[1] : keyword
      local.search(keyword)
      /* eslint-enable */
    },
    locationMapLink(venue, venueName) {
      if (this.isCN && (venue.country_id === 'tw')) {
        venue.baiduUrl = `${'//api.map.baidu.com/place/search?res=jsapi&query=' + venueName + '&region=台湾省&output=html'}`
      } else if (this.isCN) {
        this.findLocation(venue, venueName)
      } else {
        venue.baiduUrl = `${'//www.google.com.tw/maps/search/' + venueName}`
      }
      return venue.baiduUrl || ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/component/button.scss';
@import '@/assets/scss/component/table.scss';

.mk-concert-page{
  margin: 28px auto 36px;
  max-width: 1440px;
  // padding: 0 $padding-lg-grid-x1;
  .breadcrumbs{
    padding: 0 0 32px;
  }
  .content-info{
    margin-bottom: 48px;
    .image{
      width: 168px;
      height: 168px;
      border-radius: 12px;
      overflow: hidden;
      float: left;
      img{
        width: 100%;
        height: auto;
      }
    }
    .desp{
      overflow: hidden;
      padding-left: 48px;
      .title{
        font-size: 24px;
        font-weight: 500;
        line-height: 1.63;
        color: $grey-50;
        margin: 0 0 30px;
      }
    }
    &:after{
      content: "";
      display: block;
      clear: both;
    }
  }
  .btn-buy-m{
    display: none;
    width: 100%;
    margin-bottom: 36px;
  }
  .btn-location{
    display: inline-block;
    text-align: center;
    i{
      position: relative;
      width: 20px;
      height: 20px;
      font-size: 20px;
      color: $theme-red;
      vertical-align: middle;
      margin-top: -5px;
    }
  }
  .event-info{
    margin-bottom: 60px;
  }
  .event-content{
    font-size: 18px;
    line-height: 1.4;
    color: $grey-50;
    padding-bottom: 60px;
    max-width: 100%;
    word-break: break-word;
    /deep/ div {
      margin-bottom: 5px;
    }
    /deep/ img {
      margin: 10px 0;
    }
    /deep/ img, /deep/ iframe {
      max-width: 100%;
      // height: auto;
    }
  }
  .loader-container{
    text-align: center;
    .loader{
      margin-bottom: 40px;
    }
  }
}

.show-btn-buy {
  display: none !important;
}

@media only screen and (max-width: 1023.98px) {
  .mk-concert-page{
    margin: 16px auto 0;
    // padding: 0 $padding-lg-x1;
    .breadcrumbs{
      padding: 0 0 16px;
    }
    .content-info{
      margin-bottom: 16px;
      .image{
        width: 100px;
        height: 100px;
      }
      .desp{
        padding-left: 8px;
        .title{
          font-size: 20px;
          margin-bottom: 8px;
        }
      }
    }
    .btn-buy{
      display: none;
    }
    .btn-buy-m{
      display: block;
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .mk-concert-page{
    // padding: 0 $padding-xs-x1;
    .content-info{
      margin-bottom: 24px;
      .image{
        width: 70px;
        height: 70px;
      }
      .desp{
        .title{
          font-size: 16px;
          font-weight: bold;
          margin: 0;
        }
      }
    }
    .btn-buy-m{
      margin-bottom: 24px;
    }
  }
}

</style>
